import * as React from 'react'

import FinalParentSignUpForm, {
  isFinalParentSignUpFormRequired,
} from 'main/components/common/AuthModal/parent/FinalParentSignUpForm'
import { User_user } from 'main/gql/user'
import { Button } from 'main/ui'

interface IProps {
  user: User_user
  onComplete: () => void
}

export default function Confirmation(props: IProps) {
  const { user, onComplete } = props

  return isFinalParentSignUpFormRequired(user) ? (
    <FinalParentSignUpForm user={user} displayPhoneField onComplete={onComplete} />
  ) : (
    <Button onClick={() => onComplete()} full>
      Done
    </Button>
  )
}
